export const DEFAULT_LINE_HEIGHT = 1;
export const DEFAULT_RADIAL_SEGMENTS = 32;

export const DEFAULT_CONE_HEIGHT = 0.75;
export const DEFAULT_CONE_RADIUS = 0.3;

export const DEFAULT_OCTAHEDRON_RADIUS = 0.1;

export const DEFAULT_PLANE_WIDTH = 0.75;
export const DEFAULT_PLANE_HEIGHT = 0.75;
export const DEFAULT_PLANE_SEGMENTS = 32;

export const DEFAULT_RING_NUM_POINTS = 64;
export const DEFAULT_RING_RADIUS = 1;

export enum PICK_PLANE_OPACITY {
  ACTIVE = 0.75,
  INACTIVE = 0.3,
}

export const DEFAULT_CONTROLS_SEPARATION = 1;
export const DEFAULT_ROTATION_RADIUS_SCALE = 1;
export const DEFAULT_EYE_ROTATION_SCALE = 1.25;
export const DEFAULT_PLANE_SIZE_SCALE = 0.75;
export const DEFAULT_TRANSLATION_DISTANCE_SCALE = 1;

export const DEFAULT_COLOR_ARROW = "#f0ff00";
export const DEFAULT_COLOR_RING = "#f0ff00";
export const DEFAULT_COLOR_PLANE = "#f0ff00";
export const DEFAULT_CONTROLS_OPACITY = 1;
